import AppSettings from "../../../../Settings/AppSettings";
import React, { useContext, useEffect, useState } from "react";
import { CategoryContext } from "../CategoryContext";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import Label from "../../../Common/components/Label";
import { Link } from "react-router-dom";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import ButtonToggle from "./ButtonToggle";
import { ABS_ATTRIBUTES, ABS_NOT_FOUND, CF_ATTRIBUTES, CF_NOT_FOUND, LOADING_ABS, LOADING_CF, SAVING_ABS, SAVING_CF } from "../CategoryConstants";
import LoadingSuccessErrorAlert from "./LoadingSuccessErrorAlert";

const AbsAttributeOrder = ({title, id}) => {
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const { editingItem } = useContext(CategoryContext);
  const [loading, setLoading] = useState({ status: "", message: "", });
  const [list, setList] = useState(null);
  const [editPage, setEditPage] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const [absAttributeOrder, setAbsAttributeOrder] = useState(null);

  useEffect(() => {
    setAbsAttributeOrder(null);
    setLoading({ status: "", message: "", });
  }, [editingItem.id]);

  useEffect(() => {
    if (list === null && collapse) {
      load_associated_Abs_attributes();
    }
  }, [collapse]);

  useEffect(() => {
    if (editPage) {
      load_associated_Abs_attributes();
    }
  }, [editPage]);

  async function load_associated_Abs_attributes() {
    setLoading({ status: "Loading", message: title === CF_ATTRIBUTES ? LOADING_CF : LOADING_ABS });
    let res = await ServiceWrapper.doGet(
      `${api_base_url}category/${editingItem.id}/${title === CF_ATTRIBUTES ? 'cf_attributes/list' : 'absattributes/list'}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    if (!res.errorfound) {
      setLoading({ status: "Success", message: undefined });
      setAbsAttributeOrder(res.data.data);
      setList(res.data.data);
    } else {
      setLoading({ status: "Error", message: "Error while loading details" });
    }
  }

  function handle_collapse() {
    setCollapse(!collapse);
  }


  const handleToggle = (id) => {
    const fieldName = title === ABS_ATTRIBUTES ? "abs_enabled" : "cf_enabled";
    setList((prevList) =>
      prevList.map((item) =>
        item.id === id ? { ...item, [fieldName]: title === CF_ATTRIBUTES ? !item.cf_enabled :!item.abs_enabled } : item
      )
    );
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newList = Array.from(list);
    const [movedItem] = newList.splice(result.source.index, 1);
    newList.splice(result.destination.index, 0, movedItem);
    setList(newList);
  };

  async function handle_save() {
    try {
      setLoading({
        status: "Loading",
        message: title === CF_ATTRIBUTES ? SAVING_CF : SAVING_ABS,
      });
      setAbsAttributeOrder(null);
      const newOrder = [];
      const fieldName = title === ABS_ATTRIBUTES ? "abs_enabled" : "cf_enabled";
      const orderField = title === ABS_ATTRIBUTES ? 'abs_attribute_order': 'cf_attribute_order';
      list.map((item, index) => { return newOrder.push({ id: item.id, [orderField]: `${index + 1}`, [fieldName]: item?.[fieldName]}); });
       const res = await ServiceWrapper.doPost(
        `${api_base_url}category/${editingItem.id}/${title === CF_ATTRIBUTES ? 'cf_attributes/edit' : 'absattributes/edit'}`,
        newOrder,
        null,
        AuthManager.getGmsToken()
      );
      if (!res.errorfound) {
        if (res.data.done) {
          setLoading({
            status: "Success",
            message: res.data.message,
          });
          setEditPage(false);
          load_associated_Abs_attributes();
        } else {
          setLoading({
            status: "Error",
            message: res.data.message,
          });
        }
      } else {
        setLoading({
          status: "Error",
          message: "Error while saving, Please try after some time.",
        });
      }
      
    } catch (error) {
      console.error("handle_save ~ error:", error)
    } finally {
      setTimeout(() => {
        if (loading.status !== "Success")
          setLoading({ status: "", message: "",});
      }, 5000);
    }
  }

  function handle_cancel() {
    setEditPage(false);
    setList(absAttributeOrder);
  }

  return (
    <>
      <div className="accordion" id={id}>
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed shadow-none"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            aria-expanded="false"
            data-bs-target={`#flush-collapse${id}`}
            aria-controls={`flush-collapse${id}`} 
            // style={Utils.borderStyle()}
            style={{
              height: "2.6875rem",
              border: "1px solid #c9cccf",
            }}
          >
            <div>
              {editPage ? <Label message="Update" /> : ""}{" "}
              <Label message={title} />
            </div>
          </div>

          {collapse && (
            <>
              {loading.status === "Success" && (
                <>
                  {!editPage ? (
                    <div
                      className="d-inline-block float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "10px",
                      }}
                    >
                      &nbsp;
                      {absAttributeOrder && absAttributeOrder.length > 0 && (
                        <Link
                          to="#"
                          className="link-primary tw-text-xs tw-font-medium tw-cursor-pointer tw-text-[#091caa] tw-no-underline"
                          onClick={() => {setEditPage(true);}}>
                          Edit
                        </Link>
                      )}
                    </div>
                  ) : (
                    <div
                      className="d-inline-block float-end position-relative"
                      style={{
                        zIndex: "100",
                        marginTop: "-34px",
                        marginRight: "10px",
                      }}
                    >
                      <Link
                        to="#"
                        className="link-primary tw-text-xs tw-font-medium tw-cursor-pointer tw-text-[#091caa] tw-no-underline tw-mr-1.5"
                        onClick={() => setList(absAttributeOrder)}
                        disabled={ JSON.stringify(absAttributeOrder) === JSON.stringify(list)} >
                        Reset
                      </Link>
                      &nbsp;
                      <button
                        type="button"
                        className="tw-text-xs tw-font-medium tw-bg-white tw-border tw-border-[#091caa] tw-rounded tw-cursor-pointer tw-text-[#091caa] tw-w-[62px] tw-h-[24px] tw-mr-1.5"
                        onClick={() => {
                          handle_cancel();
                        }}
                      >
                        Cancel
                      </button>
                      &nbsp;
                      <button
                        type="button"
                        className="tw-text-xs tw-font-medium tw-bg-[#091caa] tw-border tw-border-[#091caa] tw-rounded tw-cursor-pointer tw-text-white tw-w-[62px] tw-h-[24px] tw-mr-1.5"
                        disabled={JSON.stringify(absAttributeOrder) === JSON.stringify(list)}
                        onClick={() => handle_save()} >
                        Save
                      </button>
                    </div>
                  )}
                </>
              )}
            </>
          )}

          <div
            id={`flush-collapse${id}`}
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingAbs"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              <LoadingSuccessErrorAlert loading={loading} />

              {loading.status === "Success" && (
                <>
                  {editPage ? (
                    <div
                    className="card p-2 bg-body"
                    style={{
                      borderBottom: "1px solid #c9cccf",
                      borderLeft: "1px solid #c9cccf",
                      borderRight: "1px solid #c9cccf",
                      borderTop: "none",
                      overflow: 'auto'
                    }}
                  >
                    <table className="table table-sm">
                      <thead>
                        <tr>
                          <th
                            className="border-0"
                            scope="col"
                            style={{
                              fontFamily: "Noto Sans",
                              fontSize: "0.875rem",
                              fontWeight: 400,
                              paddingBottom: "13px",
                              color: "#787878",
                            }}
                          >
                            Order Ranking
                          </th>
                        </tr>
                      </thead>
                      <DragDropContext onDragEnd={onDragEnd}>
                        <Droppable droppableId="droppable">
                          {(provided) => (
                            <tbody {...provided.droppableProps} ref={provided.innerRef}>
                              {list.map((item, index) => (
                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                  {(provided) => (
                                    <tr ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} className="tw-bg-white">
                                      <td className="border-0">
                                        <div className="tw-flex tw-justify-between tw-items-center tw-bg-[#F4F4F7] tw-pe-5 tw-rounded-[4px]">
                                          <span className="tw-flex tw-items-center tw-py-1.5 tw-px-2 tw-gap-2">
                                            <img alt="drag_icon" src={process.env.PUBLIC_URL + "/img/Group 17.svg"} />
                                            {index + 1}. {item.name}
                                          </span>
                                          <ButtonToggle initialState={title === CF_ATTRIBUTES ? item?.cf_enabled : item.abs_enabled} onToggle={() => handleToggle(item.id)}/>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </tbody>
                          )}
                        </Droppable>
                      </DragDropContext>
                    </table>
                  </div>
                  ) : (
                    <div
                      className="p-3"
                      style={{
                        borderBottom: "1px solid #d6d8d9",
                        borderRight: "1px solid #d6d8d9",
                        borderLeft: "1px solid #d6d8d9",
                        borderTop: "none",
                      }}
                    >
                      {absAttributeOrder && absAttributeOrder.length > 0 ? (
                        <div>
                          {absAttributeOrder.map((item, index) => {
                            const absName = `${index + 1}  ${item.name}`;
                            return (
                              <div key={absName} className="tw-w-full tw-my-1 tw-h-8 tw-pl-3 tw-py-3 tw-bg-gray-100 tw-rounded tw-justify-between  tw-items-center tw-inline-flex">
                                <label className="tw-text-sky-950 tw-text-sm">{absName}</label>
                                <ButtonToggle disabled={true} initialState={title === CF_ATTRIBUTES ? item?.cf_enabled : item.abs_enabled} onToggle={() => handleToggle(item.id)}/>
                              </div>   
                            );
                          })}
                        </div>
                      ) : (
                        <div className="alert alert-dark bg-white small p-2" role="alert">
                          <strong>{title === CF_ATTRIBUTES ? CF_NOT_FOUND : ABS_NOT_FOUND}</strong>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AbsAttributeOrder;


